import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { GalleryHeadingListComponent } from './gallery-heading-list/gallery-heading-list.component';
import { GalleryHeadingCreateComponent } from './gallery-heading-create/gallery-heading-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: GalleryHeadingListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: GalleryHeadingCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'gallery-heading-create/:id',
        component: GalleryHeadingCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GalleryHeadingRoutingModule { }
